import Blue from "~/core";

new Blue({
	name: 'Cookies Consent Popup',
	selector: ".cookies",
	setup(container) {
    const closeBtn = container.querySelector("button.cookies__close");
    const acceptBtn = container.querySelector("button.cookies__btn--accept");
    const declineBtn = container.querySelector("button.cookies__btn--decline");
		let cookiePermissionsSet = !!this.$cookie.get("cookiePermissionChosen");
		
		if (cookiePermissionsSet) {
			return;
		} else {
			const closePopup = () => container.classList.remove("is-active");
			const setCookies = async consent => {
				this.$cookie.set("cookiePermissionChosen", "true", 365250);

				await fetch("/api/cookies/consent", {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/json"
					},
					redirect: "follow",
					referrerPolicy: "no-referrer",
					body: JSON.stringify(consent)
				});
	
				closePopup();
			};

			setTimeout(() => {
				container.classList.add("is-active");
				closeBtn.focus();
			}, 500);
			
			this.$addEvents(acceptBtn, "click.prevent", () => {
				setCookies(true);
				closePopup();
			});
			// DECLINE AND CLOSE DO THE SAME THING
			this.$addEvents(closeBtn, "click.prevent", () => {
				setCookies(true);
				closePopup();
			});
			this.$addEvents(declineBtn, "click.prevent", () => {
				setCookies(false);
				closePopup();
			});
		}

	}
});